"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_datetime_1 = __importDefault(require("react-datetime"));
const emotion_1 = require("emotion");
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const moment_1 = __importDefault(require("moment"));
const utils_1 = require("./utils");
const colors_1 = require("./colors");
const MDY_DATE_FORMAT = 'Y-MM-DD';
const TIME_FORMAT = 'HH:mm zz';
const clearIconStyle = emotion_1.css({
    color: colors_1.teal.base,
    position: 'absolute',
    top: '24px',
    transform: 'translateY(-50%)',
    right: '48px',
    zIndex: '1',
    cursor: 'pointer',
    '&:hover': {
        color: colors_1.teal.darkest,
    },
});
const calendarIconStyle = emotion_1.css({
    top: '24px !important',
});
const DatePicker = props => {
    const [shouldFloat, setShouldFloat] = react_1.useState(!!props.initialValue || !!props.value);
    react_1.useEffect(() => {
        setShouldFloat(!!props.value);
    }, [props.value]);
    const id = utils_1.useMemoizedId({ label: 'datepicker' });
    const [localValue, setLocalValue] = react_1.useState(undefined);
    const { readonly, placeholder, value: valueProp, helpText, disabled, input, label, required, onClickInput, initialValue, initialViewDate, initialViewMode, onNavigate, defaultValue, viewMode, defaultViewDate, closeOnClickOutside, closeOnSelect, disableCloseOnClickOutside, onOpen, onClose, onBlur, onFocus, onViewModeChange, className, style, isClearable, onChange } = props, rest = __rest(props, ["readonly", "placeholder", "value", "helpText", "disabled", "input", "label", "required", "onClickInput", "initialValue", "initialViewDate", "initialViewMode", "onNavigate", "defaultValue", "viewMode", "defaultViewDate", "closeOnClickOutside", "closeOnSelect", "disableCloseOnClickOutside", "onOpen", "onClose", "onBlur", "onFocus", "onViewModeChange", "className", "style", "isClearable", "onChange"]);
    const value = valueProp !== undefined ? valueProp : localValue;
    const getFormat = () => (props.dateFormat && props.timeFormat
        ? `${props.dateFormat} ${props.timeFormat}`
        : (props.dateFormat || props.timeFormat));
    return (react_1.default.createElement("div", { className: emotion_1.cx('datetime', 'form-group', { 'form-group-active': shouldFloat }, className), style: style },
        input
            ? (react_1.default.createElement("label", { htmlFor: id, style: { pointerEvents: 'none', wordWrap: 'break-word', width: '80%' }, className: 'control-label', title: placeholder || label },
                placeholder || label,
                required ? react_1.default.createElement("span", { style: { color: colors_1.persimmon.base } }, " *") : ''))
            : null,
        react_1.default.createElement(react_datetime_1.default, Object.assign({ dateFormat: MDY_DATE_FORMAT, timeFormat: TIME_FORMAT, input: input, inputProps: {
                id,
                readOnly: true,
                disabled,
                required,
                onClick: onClickInput,
                style: { width: style === null || style === void 0 ? void 0 : style.width },
            }, renderInput: inputProps => {
                const formattedValue = value
                    ? moment_1.default(value).format(getFormat())
                    : '';
                return react_1.default.createElement("input", Object.assign({}, inputProps, { value: formattedValue }));
            }, onClose: () => {
                setShouldFloat(!!value);
                const onCloseHandler = onClose || onBlur; // react-datetime v2->v3 compatibility
                if (onCloseHandler) {
                    onCloseHandler();
                }
            }, onOpen: () => {
                setShouldFloat(true);
                const onOpenHandler = onOpen || onFocus; // react-datetime v2->v3 compatibility
                if (onOpenHandler) {
                    onOpenHandler();
                }
            }, initialValue: initialValue || defaultValue, initialViewDate: initialViewDate || defaultViewDate, initialViewMode: initialViewMode || viewMode, closeOnSelect: closeOnSelect, closeOnClickOutside: closeOnClickOutside || !disableCloseOnClickOutside, onNavigate: onNavigate || onViewModeChange, onChange: d => {
                if (onChange) {
                    onChange(d);
                }
                setLocalValue(d);
            } }, rest)),
        input
            ? react_1.default.createElement("i", { className: emotion_1.cx('fa', 'fa-calendar', calendarIconStyle), "aria-hidden": "true" })
            : null,
        input && value && isClearable
            ? (react_1.default.createElement("span", { className: emotion_1.cx('fa', 'fa-close', clearIconStyle), "aria-hidden": "true", onClick: e => {
                    if (onChange) {
                        onChange(undefined);
                        setLocalValue(undefined);
                        e.stopPropagation();
                    }
                } }))
            : null,
        helpText && input ? react_1.default.createElement("small", { className: 'help-block' }, helpText) : null));
};
DatePicker.propTypes = {
    placeholder: prop_types_1.default.string,
    label: prop_types_1.default.string,
    helpText: prop_types_1.default.string,
    dateFormat: prop_types_1.default.string,
    timeFormat: prop_types_1.default.string,
    readonly: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    value: prop_types_1.default.oneOf(prop_types_1.default.string, prop_types_1.default.instanceOf(Date), prop_types_1.default.object),
    input: prop_types_1.default.bool,
    onClickInput: prop_types_1.default.string,
    initialValue: prop_types_1.default.instanceOf(Date),
    initialViewMode: prop_types_1.default.string,
    initialViewDate: prop_types_1.default.instanceOf(Date),
    closeOnClickOutside: prop_types_1.default.bool,
    closeOnSelect: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    onOpen: prop_types_1.default.func,
    onClose: prop_types_1.default.func,
    onNavigate: prop_types_1.default.func,
    defaultValue: utils_1.deprecatedProp(prop_types_1.default.instanceOf(Date), 'Use initialValue instead'),
    viewMode: utils_1.deprecatedProp(prop_types_1.default.string, 'Use initialViewMode instead'),
    defaultViewDate: utils_1.deprecatedProp(prop_types_1.default.instanceOf(Date), 'Use initialViewDate instead'),
    disableCloseOnClickOutside: utils_1.deprecatedProp(prop_types_1.default.bool, 'Use closeOnClickOutside instead'),
    onBlur: utils_1.deprecatedProp(prop_types_1.default.func, 'Use onOpen instead'),
    onFocus: utils_1.deprecatedProp(prop_types_1.default.func, 'Use onClose instead'),
    onViewModeChange: utils_1.deprecatedProp(prop_types_1.default.func, 'Use onNavigate instead'),
    isClearable: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    style: react_style_proptype_1.default,
};
DatePicker.defaultProps = {
    input: true,
    closeOnSelect: true,
    dateFormat: MDY_DATE_FORMAT,
    timeFormat: TIME_FORMAT,
};
exports.default = DatePicker;
